"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useFormContext = _interopRequireDefault(require("./useFormContext"));
var _react = _interopRequireWildcard(require("react"));
var Reducers = _interopRequireWildcard(require("../reducers"));
var Types = _interopRequireWildcard(require("../types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useBuildFieldContext = function useBuildFieldContext() {
  var _a = (0, _useFormContext.default)(),
    addAdditionalInputPropForm = _a.addAdditionalInputProp,
    addFieldValidation = _a.addFieldValidation,
    formData = _a.formData,
    getFieldLabel = _a.getFieldLabel,
    getFormData = _a.getFormData,
    initializeField = _a.initializeField,
    removeFieldValidation = _a.removeFieldValidation,
    terminateField = _a.terminateField,
    validateField = _a.validateField;
  var _b = _react.default.useReducer(Reducers.FieldContextReducer, {}),
    state = _b[0],
    dispatch = _b[1];
  var addAdditionalInputProp = (0, _react.useCallback)(function (key, value) {
    if (state.fieldName) {
      addAdditionalInputPropForm(state.fieldName, key, value);
    }
  }, [addAdditionalInputPropForm, state.fieldName]);
  var addValidation = (0, _react.useCallback)(function (validationId, validationFunction, validateOnChange) {
    if (state === null || state === void 0 ? void 0 : state.fieldName) {
      addFieldValidation("".concat(state === null || state === void 0 ? void 0 : state.fieldName, "_").concat(validationId), String(state === null || state === void 0 ? void 0 : state.fieldName), validationFunction, validateOnChange);
    }
  }, [addFieldValidation, state === null || state === void 0 ? void 0 : state.fieldName]);
  var initialize = (0, _react.useCallback)(function (fieldName, defaultValue) {
    if (fieldName) {
      initializeField(fieldName, defaultValue);
    }
  }, [initializeField]);
  var removeValidation = (0, _react.useCallback)(function (validationId) {
    if (state === null || state === void 0 ? void 0 : state.fieldName) {
      removeFieldValidation(String(state.fieldName), "".concat(state === null || state === void 0 ? void 0 : state.fieldName, "_").concat(validationId));
    }
  }, [removeFieldValidation, state.fieldName]);
  var setIsRequired = (0, _react.useCallback)(function (isRequired) {
    dispatch({
      type: Types.FieldContext.ReducerActionTypes.SetIsRequired,
      payload: isRequired
    });
  }, []);
  var setFieldName = (0, _react.useCallback)(function (fieldName) {
    dispatch({
      type: Types.FieldContext.ReducerActionTypes.SetFieldName,
      payload: {
        fieldName: fieldName,
        label: getFieldLabel(fieldName)
      }
    });
  }, [getFieldLabel]);
  var setShowDefaultLabel = (0, _react.useCallback)(function (showDefaultLabel) {
    dispatch({
      type: Types.FieldContext.ReducerActionTypes.SetShowDefaultLabel,
      payload: showDefaultLabel
    });
  }, []);
  var setValidateOnChange = (0, _react.useCallback)(function (validateOnChange) {
    dispatch({
      type: Types.FieldContext.ReducerActionTypes.SetValidateOnChange,
      payload: validateOnChange
    });
  }, []);
  var terminate = (0, _react.useCallback)(function (fieldName) {
    terminateField(fieldName);
  }, [terminateField]);
  var validate = (0, _react.useCallback)(function (formData, validateOnChangeOnly) {
    validateField(String(state === null || state === void 0 ? void 0 : state.fieldName), formData || getFormData(), validateOnChangeOnly);
  }, [getFormData, state === null || state === void 0 ? void 0 : state.fieldName, validateField]);
  return (0, _react.useMemo)(function () {
    var _a;
    return {
      addAdditionalInputProp: addAdditionalInputProp,
      additionalInputProps: !state.fieldName ? {} : ((_a = formData[state.fieldName]) === null || _a === void 0 ? void 0 : _a.additionalInputProps) || {},
      addValidation: addValidation,
      initialize: initialize,
      isRequired: state.isRequired,
      label: state.label ? state.label : "",
      fieldName: state.fieldName,
      removeValidation: removeValidation,
      setIsRequired: setIsRequired,
      setFieldName: setFieldName,
      setShowDefaultLabel: setShowDefaultLabel,
      setValidateOnChange: setValidateOnChange,
      showDefaultLabel: state.showDefaultLabel,
      terminate: terminate,
      validate: validate,
      validateOnChange: state.validateOnChange
    };
  }, [addAdditionalInputProp, addValidation, formData, initialize, removeValidation, setFieldName, setIsRequired, setShowDefaultLabel, setValidateOnChange, state.fieldName, state.isRequired, state.label, state.showDefaultLabel, state.validateOnChange, terminate, validate]);
};
var _default = useBuildFieldContext;
exports.default = _default;